export enum CertificateType {
  Static = 1,
  Dynamic = 2
}
